import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightSidePanelProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearRightSidePanel(props: RearRightSidePanelProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Right Side Panel"
      width={864}
      height={106}
      viewBox="0 0 864 106"
      position={{top: 0, right: 54}}
    >
      {/* Main panel fill */}
      <path
        d="M169 93.1236C105 79.1334 29.9801 50.2896 1 46.1552V46.0023C2.26434 43.169 7.24392 36.98 18 35.0018V35C39 42 162.033 78 218 82C242.055 83.7193 266.035 85.732 283 86L313 86H332H376C405 86 472.063 81.5209 512 70C557.063 57.0001 596 48.1107 596 30C596 12 563 1.00009 536 1.00009L684 1C706 2.00005 747 15.0007 770 25.0012C784.95 31.5016 802.083 40.364 810 42.0021C837.013 47.5912 845.633 58.9761 852 71.0036C854.101 74.9724 857.259 80.0631 861 87.0044C829.751 73.6959 757 73.0037 717 73.0037C651 75.0038 601 81.0041 588 93.0047C476 108.006 282.993 107.215 208 100.005C196.068 98.858 182.784 96.0767 169 93.1236Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M684 1C706 2.00005 747 15.0007 770 25.0012C784.95 31.5016 802.083 40.364 810 42.0021C837.013 47.5912 845.633 58.9761 852 71.0036C854.101 74.9724 857.259 80.0631 861 87.0044C829.751 73.6959 757 73.0037 717 73.0037C651 75.0038 601 81.0041 588 93.0047C476 108.006 282.993 107.215 208 100.005C196.068 98.858 182.784 96.0767 169 93.1236C105 79.1334 29.9801 50.2896 1 46.1552V46.0023C2.26434 43.169 7.24392 36.98 18 35.0018V35C39 42 162.033 78 218 82C242.055 83.7193 266.035 85.732 283 86L313 86H332H376C405 86 472.063 81.5209 512 70C557.063 57.0001 596 48.1107 596 30C596 12 563 1.00009 536 1.00009C603.561 1.00006 616.439 1.00004 684 1ZM684 1L686 1.00009"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M595 24.6957C688.031 26.1719 762 28.8696 783 30.9565"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Fuel Door fill */}
      <path
        d="M661.472 17.0212L677.448 17.6714L693.423 18.3215C698.416 18.5247 704.617 22.894 703.951 29.5266C703.288 36.1292 696.498 37.1966 693.633 36.9733L675.66 36.2419L658.584 35.547C654.691 35.3886 646.627 33.5005 648.201 23.339C649.093 17.5796 657.11 16.8522 661.472 17.0212Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M661.472 17.0212L677.448 17.6714L693.423 18.3215C698.416 18.5247 704.617 22.894 703.951 29.5266C703.288 36.1292 696.498 37.1966 693.633 36.9733L675.66 36.2419L658.584 35.547C654.691 35.3886 646.627 33.5005 648.201 23.339C649.093 17.5796 657.11 16.8522 661.472 17.0212Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
